import Vue from "vue";
import VueI18n from "vue-i18n";
import en from './en'
import cn from './cn'
import de from './de'
import es from './es'
import fr from './fr'
import it from './it'
import ja from './ja'
import ko from './ko'
import pt from './pt'
import ar from './ar'
import du from './du'
import pl from './pl'
import ro from './ro'
import ru from './ru'

Vue.use(VueI18n); // 全局挂载

export const i18n = new VueI18n({
    locale: localStorage.getItem("locale") || "en", // 从localStorage中获取 默认英文
    messages: {
      en,
      cn,
      de,
      es,
      fr,
      it,
      ja,
      ko,
      pt,
      ar,
      du,
      pl,
      ro,
      ru
    },
    silentTranslationWarn:true
  });
   
  export default i18n;